var _VideoPlayerIcon;
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@crehana/compass.ui/v2';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
import { useTranslation } from "../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VideoPlayerIcon = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-p1a0yn-0"
})(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 24px;\n"]);
var VideoPlayerContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-p1a0yn-1"
})(["\n  width: 120px;\n  height: 80px;\n  background-color: white;\n  border-radius: 8px;\n  position: relative;\n  margin-bottom: 12px;\n"]);
var VideoScreen = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-p1a0yn-2"
})(["\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  right: 8px;\n  bottom: 20px;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n"]);
var ProgressBar = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-p1a0yn-3"
})(["\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  right: 8px;\n  height: 4px;\n  background-color: #e5e7eb;\n  border-radius: 2px;\n  overflow: hidden;\n"]);
var ProgressFill = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-p1a0yn-4"
})(["\n  height: 100%;\n  width: 30%;\n  background-color: #8b5cf6;\n  border-radius: 2px;\n"]);
var PlayerBlockedModal = function PlayerBlockedModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(Dialog, {
    open: isOpen,
    onOpenChange: onClose,
    children: /*#__PURE__*/_jsxs(DialogContent, {
      className: "tw-bg-elevation-dark-00",
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        className: "tw-text-left tw-mb-2 tw-pt-1.6",
        children: /*#__PURE__*/_jsx(DialogTitle, {
          className: "tw-text-neutral-light-100",
          children: t('BLOCKED_TITLE')
        })
      }), /*#__PURE__*/_jsxs(DialogDescription, {
        className: "tw-text-neutral-light-100",
        children: [_VideoPlayerIcon || (_VideoPlayerIcon = /*#__PURE__*/_jsx(VideoPlayerIcon, {
          children: /*#__PURE__*/_jsxs(VideoPlayerContainer, {
            children: [/*#__PURE__*/_jsx(VideoScreen, {}), /*#__PURE__*/_jsx(ProgressBar, {
              children: /*#__PURE__*/_jsx(ProgressFill, {})
            })]
          })
        })), t('BLOCKED_TIMESTAMP_LABEL')]
      }), /*#__PURE__*/_jsx(DialogFooter, {
        className: "tw-bg-neutral-dark-700",
        children: /*#__PURE__*/_jsx(Button, {
          type: "button",
          onClick: onConfirm,
          size: "lg",
          className: "tw-w-full tw-block",
          children: t('BLOCKED_BUTTON_LABEL')
        })
      })]
    })
  });
};
export default PlayerBlockedModal;